import { render, staticRenderFns } from "./PaginationNumber.vue?vue&type=template&id=d45ccddc"
import script from "./PaginationNumber.vue?vue&type=script&lang=js"
export * from "./PaginationNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports